// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconMicrophone = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M22 23C22 8.37109 23.3948 6 32 6C40.6052 6 42 8.37109 42 23C42 37.6289 40.6052 40 32 40C23.3948 40 22 37.6289 22 23ZM50 27C48.1566 27 47 28.1565 47 30C47 40.0938 42.0938 45 32 45C21.9062 45 17 40.0938 17 30C17 28.1565 15.8434 27 14 27C12.1566 27 11 28.1565 11 30C11 39.5245 14.9164 46.1299 22 49.1432V53C22 54.8511 23.1489 56 25 56H39C40.8511 56 42 54.8511 42 53V49.1432C49.0836 46.1299 53 39.5245 53 30C53 28.1565 51.8434 27 50 27Z" />
    </svg>
  );
};
